import { mergeDeep } from '@appbolaget/helpers';
import { AwareTableColumn } from '@components/aw-table-2/symbols';

export const Posts: { [key: string]: PostConfig } = {
    global: {
        icon: 'speaker_notes',
        route: 'posts',
        expand: 'meta,media,categories,attributes',
        model: 'post',
        createNew: {
            enabled: true,
            requiredPermissions: 'post.create',
        },
        detailsRoute: {
            enabled: false,
        },
        label: {
            singular: 'PAGE_PAGES.PAGE',
            plural: 'PAGE_PAGES.PAGES',
            createNew: 'PAGE_PAGES.NEW',
        },
        fields: {
            attributes: {
                enabled: false,
                fields: {},
            },
            category: {
                enabled: true,
                multiple: true,
            },
            content: {
                enabled: true,
                wysiwyg: true,
            },
            excerpt: {
                enabled: true,
            },
            expire_at: {
                enabled: false,
                time: true,
            },
            geolocation: {
                enabled: false,
            },
            media: {
                enabled: true,
                primaryImage: true,
            },
            meta: {
                enabled: false,
            },
            publish_at: {
                enabled: true,
                time: true,
            },
            scheduling: {
                enabled: false,
                required: false,
            },
            start_at: {
                enabled: false,
                time: true,
            },
            end_at: {
                enabled: false,
                time: true,
            },
            notification: {
                push: {
                    enabled: false,
                },
                internal: {
                    enabled: false,
                },
            },
            reminders: {
                enabled: false,
            },
        },

        connections: {
            enabled: false,
        },
    },
};

Posts.activity = mergeDeep({}, Posts.global, {
    route: 'posts',
    type: 'activity',
    icon: 'date_range',
    expand: 'meta,media,clients,categories,parent,attributes,reminders',
    mergeQueryParams: {
        start_at: 'start_at',
    },
    label: {
        singular: 'PAGE_OCCASIONS.OCCASION',
        plural: 'PAGE_OCCASIONS.OCCASIONS',
        createNew: 'PAGE_OCCASIONS.NEW',
    },
    fields: {
        category: {
            enabled: true,
        },
        excerpt: {
            enabled: false,
        },
        expire_at: {
            enabled: true,
        },
        media: {
            primaryImage: false,
        },
        attributes: {
            enabled: true,
            fields: {
                seats: {
                    label: 'Max antal deltagare',
                    attributeType: 'simple',
                    inputType: 'text',
                    textType: 'number',
                },
                location__name: {
                    label: 'Plats',
                    attributeType: 'simple',
                    inputType: 'text',
                },
                location__address: {
                    label: 'Adress',
                    attributeType: 'simple',
                    inputType: 'text',
                },
                location__comment: {
                    label: 'Plats - extrainformation',
                    attributeType: 'simple',
                    inputType: 'text',
                },
                external_link: {
                    label: 'Extern url',
                    attributeType: 'simple',
                    inputType: 'text',
                    textType: 'url',
                },
                digital: {
                    label: 'Digital aktivitet',
                    attributeType: 'simple',
                    inputType: 'checkbox',
                    isBoolean: true,
                },
            },
        },
        meta: {
            enabled: false,
            fields: {
                location__name: {
                    type: 'text',
                    label: 'Plats',
                },
                location__address: {
                    type: 'text',
                    label: 'Adress',
                },
                location__comment: {
                    type: 'text',
                    label: 'Plats - extrainformation',
                },
                external_link: {
                    type: 'text',
                    label: 'Extern url',
                },
            },
        },
        scheduling: {
            enabled: false,
            required: false,
        },
        start_at: {
            enabled: true,
            required: true,
        },
        end_at: {
            enabled: true,
            required: true,
        },
        reminders: {
            enabled: true,
            multiple: true,
        },
    },
    connections: {
        enabled: true,
        fields: {
            clients: {
                route: 'clients/search',
                parameters: {
                    roles: JSON.stringify(['administrator', 'coach', 'resource']),
                },
                multiple: true,
                search: true,
                anchorProperty: 'clients',
                label: 'Kontaktperson',
                collectionModel: 'client',
                pivot: {
                    status: 'contact',
                },
                nativeAttach: 'clients',
            },
        },
    },
} as PostConfig);

Posts.alert = mergeDeep({}, Posts.global, {
    type: 'alert',
    icon: 'campaign',
    expand: '',
    label: {
        singular: 'POST.ALERT.LABEL.singular',
        plural: 'POST.ALERT.LABEL.plural',
        createNew: 'POST.ALERT.LABEL.createNew',
    },
    fields: {
        category: {
            enabled: false,
        },
        media: {
            enabled: false,
        },
        excerpt: {
            enabled: false,
        },
    },
} as PostConfig);

Posts.category = mergeDeep({}, Posts.global, {
    type: 'category',
    icon: 'folder',
    route: 'categories',
    expand: 'meta,media',
    model: 'category',
    extraParams: {
        expand: 'meta',
    },
    // stream: {
    //     direction: 'up',
    //     column: 'unit_id',
    // },
    label: {
        singular: 'PAGE_CATEGORIES.CATEGORY',
        plural: 'PAGE_CATEGORIES.CATEGORIES',
        createNew: 'PAGE_CATEGORIES.NEW',
    },
    fields: {
        category: {
            enabled: false,
        },
        media: {
            primaryImage: false,
        },
        meta: {
            enabled: true,
            fields: {
                color: {
                    type: 'color',
                    label: 'Färg',
                },
            },
        },
    },
    entityTypes: [
        {
            label: 'Aktivitet',
            value: 'category',
        },
        {
            label: 'Hjälpkategori',
            value: 'help',
        },
    ],
    extraColumns: [
        {
            prop: 'color',
            name: 'Färg',
            cellTemplate: 'color',
            disableSorting: true,
        },
    ],
} as PostConfig);

Posts.help = mergeDeep({}, Posts.global, {
    type: 'help',
    icon: 'help',
    expand: 'meta,media,categories,attributes',
    label: {
        singular: 'POST.HELP.LABEL.singular',
        plural: 'POST.HELP.LABEL.plural',
        createNew: 'POST.HELP.LABEL.createNew',
    },
    fields: {
        attributes: {
            enabled: true,
            customAttributes: {
                enabled: true,
                requiredPermissions: '*.*.*',
            },
            keywords: {
                enabled: true,
            },
            fields: {},
        },
        category: {
            enabled: true,
            multiple: true,
            type: 'help',
        },
        media: {
            enabled: false,
        },
    },
} as PostConfig);

Posts.lunch_week = mergeDeep({}, Posts.global, {
    type: 'lunch_week',
    icon: 'fastfood',
    expand: 'meta,media,attributes,units,client',
    useWeekRangeEditor: true,
    extraParams: {
        expand: 'client,media',
    },
    extraColumns: [
        {
            name: 'PAGE_POSTS.WRITER',
            prop: 'client.name',
            disableSorting: true,
        },
    ],

    label: {
        singular: 'PAGE_FOOD.FOOD_MENU',
        plural: 'PAGE_FOOD.FOOD_MENU_PLURAL',
        createNew: 'PAGE_FOOD.NEW',
    },
} as PostConfig);

Posts.weekschedule = mergeDeep({}, Posts.global, {
    type: 'weekschedule',
    icon: 'event_note',
    expand: 'meta,media,attributes,units,client',
    useWeekRangeEditor: true,
    extraParams: {
        expand: 'client,media',
    },
    extraColumns: [
        {
            name: 'PAGE_POSTS.WRITER',
            prop: 'client.name',
            disableSorting: true,
        },
    ],

    label: {
        singular: 'PAGE_WEEKLY_SCHEDULE.SCHEDULE',
        plural: 'PAGE_WEEKLY_SCHEDULE.SCHEDULE',
        createNew: 'PAGE_WEEKLY_SCHEDULE.NEW',
    },
} as PostConfig);

Posts.news = mergeDeep({}, Posts.global, {
    type: 'news',
    icon: 'rss_feed',
    expand: 'meta,media.children,categories,attributes,units',
    label: {
        singular: 'PAGE_NEWS.NEWS_ONE',
        plural: 'PAGE_NEWS.NEWS_MANY',
        createNew: 'PAGE_NEWS.NEW',
    },
    extraParams: {
        expand: 'client',
    },
    extraColumns: [
        {
            name: 'PAGE_POSTS.WRITER',
            prop: 'client.name',
            disableSorting: true,
        },
    ],
    fields: {
        category: {
            enabled: false,
        },
        media: {
            enabled: true,
            primaryImage: false,
        },
        meta: {
            enabled: true,
            fields: {
                external_link: {
                    type: 'text',
                    label: 'PAGE_POSTS.EXTERNAL_URL',
                },
            },
        },
        notification: {
            push: {
                enabled: true,
            },
        },
    },
    connections: {
        enabled: false, // Disabled completely because feels like it doesnt work. Post also lands on active unit right?
        fields: {
            units: {
                label: 'PAGE_POSTS.UNITS_SHOW_NEWS',
                route: 'units/search',
                parameters: {
                    type: 'department',
                    scope: 'units',
                    stream: 'down',
                    expand: 'parent',
                },
                multiple: true,
                search: true,
                anchorProperty: 'units',
                collectionModel: 'unit',
                pivot: {
                    status: 'contact',
                },
                visibleOnUnitType: 'department',
            },
        },
    },
} as PostConfig);

Posts.noticeboard = mergeDeep({}, Posts.news, {
    type: 'note',
    icon: 'assignment',
    label: {
        singular: 'PAGE_NOTICEBOARD.NOTE_ONE',
        plural: 'PAGE_NOTICEBOARD.NOTES_MANY',
        createNew: 'PAGE_NOTICEBOARD.NEW',
    },
} as PostConfig);

Posts.occasion = mergeDeep({}, Posts.global, {
    type: 'occasion',
    icon: 'query_builder',
    expand: 'meta,media,categories,attributes,reminders',
    label: {
        singular: 'PAGE_OCCASIONS.OCCASION',
        plural: 'PAGE_OCCASIONS.OCCASIONS',
        createNew: 'PAGE_OCCASIONS.NEW',
    },
    fields: {
        attributes: {
            enabled: true,
            customAttributes: {
                enabled: false,
                requiredPermissions: '*.*.*',
            },
            fields: {
                seats: {
                    label: 'PAGE_OCCASIONS.ATTRIBUTES.AVAILABLE_SEATS',
                    attributeType: 'simple',
                    inputType: 'text',
                    textType: 'number',
                },
            },
        },
        scheduling: {
            enabled: false,
            required: false,
        },
        start_at: {
            enabled: true,
            required: true,
        },
        end_at: {
            enabled: true,
            required: true,
        },
        expire_at: {
            enabled: true,
        },
        meta: {
            enabled: true,
            fields: {
                organizer: {
                    type: 'text',
                    label: 'PAGE_OCCASIONS.ATTRIBUTES.ORGANIZER_NAME',
                },
                organizer_email: {
                    type: 'text',
                    label: 'PAGE_OCCASIONS.ATTRIBUTES.ORGANIZER_EMAIL',
                },
                organizer_phone: {
                    type: 'text',
                    label: 'PAGE_OCCASIONS.ATTRIBUTES.ORGANIZER_PHONE',
                },
                url: {
                    type: 'text',
                    label: 'PAGE_OCCASIONS.ATTRIBUTES.WEBSITE',
                },
                address: {
                    type: 'text',
                    label: 'PAGE_OCCASIONS.ATTRIBUTES.ADDRESS',
                },
                hours: {
                    type: 'textarea',
                    label: 'PAGE_OCCASIONS.ATTRIBUTES.OPENING_HOURS',
                },
                cost: {
                    type: 'textarea',
                    label: 'PAGE_OCCASIONS.ATTRIBUTES.PRICING',
                },
            },
        },
        reminders: {
            enabled: false,
            multiple: false,
        },
    },
} as PostConfig);

Posts.orgFeedback = mergeDeep({}, Posts.global, {
    type: 'org-feedback',
    icon: 'rate_review',
    expand: 'media,attributes',
    stream: {
        direction: 'down',
        column: 'unit_id',
    },
    label: {
        singular: 'POST.ORG-FEEDBACK.LABEL.singular',
        plural: 'POST.ORG-FEEDBACK.LABEL.plural',
        createNew: 'POST.ORG-FEEDBACK.LABEL.createNew',
    },
    createNew: {
        enabled: false,
    },
    detailsRoute: {
        enabled: true,
        route: ['/app', 'feedback'],
    },
    fields: {
        category: {
            enabled: false,
        },
        media: {
            enabled: true,
        },
    },
} as PostConfig);

Posts.page = mergeDeep({}, Posts.global, {
    type: 'page',
    icon: 'speaker_notes',
    expand: 'meta,media,categories,locations,clients,attributes,direct-files',
    label: {
        singular: 'PAGE_PAGES.PAGE',
        plural: 'PAGE_PAGES.PAGES',
        createNew: 'PAGE_PAGES.NEW',
    },
    detailsRoute: {
        enabled: true,
        route: ['/app', 'posts'],
    },
    fields: {
        attributes: {
            enabled: false,
            customAttributes: {
                enabled: false,
                requiredPermissions: '*.*.*',
            },
            keywords: {
                enabled: true,
            },
            fields: {
                // role: {
                //     attributeType: 'simple',
                //     label: 'Roll',
                //     inputType: 'select',
                //     selectOptions: {
                //         multiple: true,
                //         options: [
                //             {
                //                 label: 'Alla',
                //                 value: '*',
                //             },
                //             {
                //                 label: 'Invånare',
                //                 value: 'participant',
                //             },
                //         ],
                //     },
                // },
            },
        },
        expire_at: {
            enabled: true,
        },
        media: {
            directUpload: true,
        },
    },
    connections: {
        enabled: false,
        fields: {
            location: {
                route: 'locations',
                anchorProperty: 'locations',
                label: 'Plats',
                multiple: true,
                search: false,
                collectionModel: 'location',
                parameters: {
                    type: 'custom',
                },
            },
            client: {
                route: 'clients/search',
                anchorProperty: 'clients',
                label: 'Användare',
                collectionModel: 'client',
                multiple: true,
                search: true,
            },
        },
    },
} as PostConfig);

Posts.story = mergeDeep({}, Posts.global, {
    type: 'story',
    icon: 'book',
    label: {
        singular: 'PAGE_STORIES.STORY',
        plural: 'PAGE_STORIES.STORIES',
        createNew: 'PAGE_STORIES.NEW',
    },
} as PostConfig);

Posts.systemnotice = mergeDeep({}, Posts.global, {
    type: 'systemnotice',
    icon: 'update',
    expand: 'meta,media,categories,attributes',
    label: {
        singular: 'POST.SYSTEMNOTICE.LABEL.singular',
        plural: 'POST.SYSTEMNOTICE.LABEL.plural',
        createNew: 'POST.SYSTEMNOTICE.LABEL.createNew',
    },
    fields: {
        attributes: {
            enabled: true,
            customAttributes: {
                enabled: true,
                requiredPermissions: '*.*.*',
            },
            keywords: {
                enabled: true,
            },
            fields: {},
        },
        category: {
            enabled: false,
        },
        media: {
            enabled: false,
        },
        notification: {
            internal: {
                enabled: true,
            },
        },
    },
} as PostConfig);

Posts.weekletter = mergeDeep({}, Posts.global, {
    type: 'weekletter',
    icon: 'mark_as_unread',
    expand: 'meta,media,categories,attributes',
    label: {
        singular: 'POST.WEEKLETTER.LABEL.singular',
        plural: 'POST.WEEKLETTER.LABEL.plural',
        createNew: 'POST.WEEKLETTER.LABEL.createNew',
    },
    extraParams: {
        expand: 'client',
    },
    extraColumns: [
        {
            name: 'PAGE_POSTS.WRITER',
            prop: 'client.name',
            disableSorting: true,
        },
    ],
    fields: {
        category: {
            enabled: false,
        },
        media: {
            enabled: true,
        },
        notification: {
            push: {
                enabled: true,
            },
        },
    },
} as PostConfig);

export interface PostConfig {
    /**
     * Post type
     */
    type?: string;

    /**
     * Icon for the table page header and other places maybe
     */
    icon?: string;

    /**
     * List route
     */
    route?: string;

    /**
     * This expand is only for the edit page request
     */
    expand?: string;

    /**
     * Model in string format for collection mapping
     */
    model?: string;

    /**
     * Columns here will be added to the table after the title property
     */
    extraColumns?: AwareTableColumn[];

    /**
     * Params added here are added to the request in the table view
     */
    extraParams?: any;

    stream?: {
        direction: 'up' | 'down' | '*';
        column: string;
    };

    createNew?: {
        enabled: boolean;
        requiredPermissions?: string | string[];
    };

    /**
     * Specify additional entity types if needed.
     * Example: Categories are often filtered by type.
     */
    entityTypes?: { label: string; value: string }[];

    /**
     * If you need a custom show route, specify here
     */
    showRoute?: string;

    /**
     * If you need a custom details page, specify here
     */
    detailsRoute?: {
        enabled: boolean;
        route?: string[];
    };

    /**
     * Decides if we use the week range editor for this.
     */
    useWeekRangeEditor?: boolean;

    /**
     * Specify query params in the uri that should also be included in the show http request
     */
    mergeQueryParams?: { [key: string]: string };

    label: {
        singular: string;
        plural: string;
        createNew: string;
    };
    fields?: {
        attributes?: {
            enabled: boolean;
            customAttributes?: {
                enabled: boolean;
                requiredPermissions?: string | string[];
            };
            keywords?: {
                enabled: boolean;
                requiredPermissions?: string | string[];
            };
            fields: {
                [key: string]: {
                    label: string;
                    attributeType: 'simple' | 'text' | 'json';
                    inputType: 'text' | 'textarea' | 'color' | 'select' | 'checkbox';
                    isBoolean?: boolean;
                    textType?: 'text' | 'url' | 'tel' | any;
                    selectOptions?: {
                        multiple?: boolean;
                        options?: {
                            label: string;
                            value: any;
                        }[];
                    };
                };
            };
        };
        category?: {
            enabled?: boolean;
            multiple?: boolean;
            type?: string;
            pivot?: PivotOptions;
        };
        content?: {
            enabled?: boolean;
            wysiwyg?: boolean;
        };

        excerpt?: {
            enabled?: boolean;
        };

        publish_at?: {
            enabled: boolean;
            label?: string;
            time?: boolean;
        };

        expire_at?: {
            enabled: boolean;
            label?: string;
            time?: boolean;
        };

        geolocation?: {
            enabled: boolean;
        };

        media?: {
            enabled?: boolean;
            primaryImage?: boolean;
            directUpload?: boolean;
            pivot?: PivotOptions;
        };
        meta?: {
            enabled: boolean;
            fields?: {
                [key: string]: {
                    label: string;
                    type: string;
                    inputType?: string;
                };
            };
        };
        scheduling?: {
            enabled: boolean;
            required: boolean;
        };

        start_at?: {
            enabled: boolean;
            required?: boolean;
            label?: string;
            time?: boolean;
        };

        end_at?: {
            enabled: boolean;
            required?: boolean;
            label?: string;
            time?: boolean;
        };

        notification?: {
            push?: {
                enabled: boolean;
            };

            internal?: {
                enabled: boolean;
                requiredPermissions?: string | string[];
            };
        };

        reminders?: IReminders;
    };

    connections?: {
        enabled: boolean;
        requiredPermissions?: string | string[];
        attachToUnits?: {
            enabled: boolean;
            roles?: string[];
            label?: string;
            pivot?: PivotOptions;
        };
        fields?: {
            [key: string]: IPostConnection;
        };
    };
}

export interface PivotOptions {
    status?: string;
    meta?: any;
}

export interface IReminders {
    enabled: boolean;
    multiple?: boolean;
    requiredPermissions?: string | string[];
    disabledOnScheduled?: boolean;
}

export interface IPostConnection {
    disabled?: boolean;
    requiredPermissions?: string | string[];
    label: string;
    route: string;
    module?: string;
    multiple?: boolean;
    search?: boolean;
    anchorProperty: string;
    collectionModel: string;
    subDisplay?: string;
    parameters?: {
        expand?: string;
        type?: string;
    };
    filter?: {
        [key: string]: any;
    };
    pivot?: PivotOptions;

    /**
     * If set, the connection will be on the main post body, not a seperate request
     */
    nativeAttach?: string;
}
